import { SmartToy } from "@mui/icons-material";
import { Box, Divider, Stack, Tooltip, Typography } from "@mui/material";
import CreateTaskForm from "./components/CreateTaskForm";

const isLocalhost = window.location.hostname === "localhost";
const graphqlUrl = import.meta.env.VITE_GRAPHQL_URL ?? "unknown";

export default function App() {
  return (
    <Box sx={{ p: 2, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Stack direction="row" sx={{ alignItems: "center", mb: 0.5 }} spacing={1.5}>
        <SmartToy sx={{ fontSize: 32 }} />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Create RainONE Task
        </Typography>
      </Stack>
      <Divider sx={{ mb: 2 }} />
      <CreateTaskForm />
      <Box sx={{ flexGrow: 1 }} />
      <Tooltip title={`App: ${window.location.origin}\nAPI: ${graphqlUrl}`} placement="top-end">
        <Typography
          sx={{ textAlign: "right", cursor: "default", fontSize: 10, lineHeight: 1 }}
        >
          {isLocalhost ? "🟡" : "🟢"}
        </Typography>
      </Tooltip>
    </Box>
  );
}
